import { Modal } from '@app/components/common/Modal/Modal';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IDealRoomMenuSection, IDealRoomSection, IDealRoomSectionContent } from '@app/interfaces/deal-room';
import { DisabledMenu } from './DisabledMenu';
import { Tabs } from '../../Tabs/Tabs';
import { Button } from '../../buttons/Button/Button';
import { Category } from './Category';

export interface ChooseDisabledMenuProps {
  loading: boolean;
  isOpen: boolean;
  dealRoomId: string;
  sections: IDealRoomSection[];
  menuSections: IDealRoomMenuSection[];
  onClose: () => void;
  onSelect: (file: IDealRoomSectionContent[]) => void;
  onRemoveMenu: (menu: string) => void;
}

export const ChooseDisabledMenu: React.FC<ChooseDisabledMenuProps> = ({
  loading,
  isOpen,
  dealRoomId,
  sections,
  menuSections,
  onClose,
  onSelect,
  onRemoveMenu,
}) => {
  const { t } = useTranslation();
  const [addCount, setAddCount] = useState(0);
  const [activeTab, setActiveTab] = useState('1');

  const tabItems = [
    {
      label: t('dealRooms.selectMenu.menu'),
      key: '1',
      children: (
        <DisabledMenu
          dealRoomId={dealRoomId}
          sections={sections}
          menuSections={menuSections}
          addCount={addCount}
          activeTab={activeTab}
          onSelect={onSelect}
          onRemoveMenu={onRemoveMenu}
        />
      ),
    },
    {
      label: t('dealRooms.selectMenu.categories'),
      key: '2',
      children: <Category dealRoomId={dealRoomId} />,
    },
  ];

  const renderFooter = () => {
    if (activeTab === '1') {
      return (
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
          <Button onClick={onClose}>{t('common.cancel')}</Button>
          <Button type="primary" loading={loading} onClick={() => setAddCount((prev) => prev + 1)}>
            {t('dealRooms.selectMenu.add')}
          </Button>
        </div>
      );
    }
    return (
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
        <Button onClick={onClose}>{t('common.cancel')}</Button>
      </div>
    );
  };

  return (
    <Modal
      title={t('dealRooms.selectMenu.addSectionToSite')}
      size="extraLarge"
      open={isOpen}
      onCancel={onClose}
      destroyOnClose
      closable={true}
      maskClosable={false}
      confirmLoading={loading}
      footer={renderFooter()}
    >
      <Tabs
        className="share-deal-room"
        tabPosition="left"
        type="card"
        items={tabItems}
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key)}
      />
    </Modal>
  );
};
